import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  margin-top: 10px;
  height: calc(100% - 200px);
  border-radius: 10px;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
`;

export const PartnerSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PartnerName = styled.h3`
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.text.primary};
  font-size: 16px;
  font-weight: 500;
`;

export const VenueList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VenueItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
`;

export const NoVenues = styled.div`
  padding: 16px;
  text-align: center;
  color: ${({ theme }) => theme.text.secondary};
`;
